const ALARM_KEY_MAP: Record<string, string> = {
	meter_blocked: "meter_blocked",
	underflow: "underflow",
	overflow: "overflow",
	back_flow: "back_flow",
	mechanical_fraud: "mechanical_fraud",
	leakage: "leakage",
	leakage_currently: "leakage_currently",
	"CRC_ERROR LEAKAGE_OR_NO_USAGE": "crc_error_leakage_or_no_usage",
	CRC_ERROR: "crc_error",
	"ERROR_FLAGS_20 ALARM TEMPORARY_ERROR":
		"error_flags_20_alarm_temporary_error",
	"TEMPORARY_ERROR VOLTAGE_INTERRUPTED": "temporary_error_voltage_interrupted",
	GW_ERROR_GENERAL: "gw_error_general",
	GW_ERROR_IO: "gw_error_io",
	GW_ERROR_POWER: "gw_error_power",
	GW_ERROR_BAD_ARGUMENT: "gw_error_bad_argument",
	GW_ERROR_WRONG_STATE: "gw_error_wrong_state",
	GW_ERROR_RESOURCE_UNAVAILABLE: "gw_error_resource_unavailable",
	GW_ERROR_INSUFFICIENT_MEMORY: "gw_error_insufficient_memory",
	GW_ERROR_PERMISSION_DENIED: "gw_error_permission_denied",
	GW_ERROR_RESOURCE_BUSY: "gw_error_resource_busy",
	GW_ERROR_VALUE_TOO_LARGE: "gw_error_value_too_large",
	GW_ERROR_OUT_OF_RANGE: "gw_error_out_of_range",
	GW_ERROR_UNSUPPORTED: "gw_error_unsupported",
	GW_ERROR_FILE_NOT_EXISTS: "gw_error_file_not_exists",
	GW_ERROR_FILE_EXISTS: "gw_error_file_exists",
	GW_ERROR_FILE_READ: "gw_error_file_read",
	GW_ERROR_FILE_WRITE: "gw_error_file_write",
	GW_ERROR_TIMEOUT: "gw_error_timeout",
	GW_ERROR_NETWORK: "gw_error_network",
	GW_ERROR_PROTOCOL: "gw_error_protocol",
	GW_ERROR_INPROGRESS: "gw_error_inprogress",
	GW_ERROR_CANCELLED: "gw_error_cancelled",
	GW_ERROR_NO_BUFF_SPACE: "gw_error_no_buff_space",
	GW_ERROR_PARSING: "gw_error_parsing",
	GW_ERROR_NETWORK_DOWN: "gw_error_network_down",
	GW_ERROR_NETWORK_UNREACHABLE: "gw_error_network_unreachable",
	GW_ERROR_NETWORK_UNAVAILABLE: "gw_error_network_unavailable",
	GW_ERROR_CONNECTION_RESET: "gw_error_connection_reset",
	GW_ERROR_CONNECTION_TIMEOUT: "gw_error_connection_timeout",
	GW_ERROR_CONNECTION_REFUSED: "gw_error_connection_refused",
	GW_ERROR_HOST_UNREACHABLE: "gw_error_host_unreachable",
	GW_ERROR_NO_KEY: "gw_error_no_key",
	GW_ERROR_KEY_EXPIRED: "gw_error_key_expired",
	GW_ERROR_KEY_REJECTED: "gw_error_key_rejected",
};

export function getAlertDescriptionKey(alarm: string): string | null {
	const slug = ALARM_KEY_MAP[alarm];
	return slug ? `alertDescriptions.${slug}` : null;
}
